import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function updateFilterConfig() {
    return (
        <div data-cy="historic-icon-updateFilterConfig">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.updateFilterConfig" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faFilter} size="lg" style={{ color: '#2184da' }} />
            </Whisper>
        </div>
    );
}
